<template>
  <v-tabs
    v-if="$vuetify.breakpoint.mdAndUp"
    :value="value"
    class="w-help-tabs"
    vertical
    @input="$emit('input', $event)"
  >
    <v-tab
      v-for="(entry, index) in helpTabs"
      :key="index"
      class="w-help-tab"
    >
      {{ entry.module }}
    </v-tab>

    <v-tab-item
      v-for="(entry, index) in helpTabs"
      :key="index"
    >
      <v-card flat>
        <v-card-text
          class="w-help-tab-content"
          v-html="parseMarkdown(entry.text)"
        />
      </v-card>
    </v-tab-item>
  </v-tabs>

  <v-container
    v-else
    fluid
  >
    <w-row>
      <w-column>
        <w-autocomplete
          :label="$t('Common.help')"
          :value="value"
          :items="helpTabs"
          item-text="module"
          return-object
          @input="$emit('input', $event)"
        />
      </w-column>
    </w-row>

    <w-row>
      <w-column>
        <v-card-text
          class="w-help-tab-content"
          v-html="parseMarkdown(value.text)"
        />
      </w-column>
    </w-row>
  </v-container>
</template>

<script>
import { marked } from "marked"

export default {
  props: {
    value: { type: [Number, Object], required: true },
    helpTabs: { type: Array, required: true }
  },
  methods: {
    parseMarkdown(file) {
      if (!file) { return }
      return marked.parse(file);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/app/typography";
.w-help-tabs ::v-deep {
  height: 100%;

  .v-slide-group__content {
    overflow-y: auto;
  }

  .v-tabs-slider-wrapper {
    width: $slider-line__thickness--active !important;
  }

  .v-window {
    overflow-y: auto;
  }
}

.w-help-tab {
  justify-content: flex-start;
  min-height: 2.75rem;

  text-transform: none;
  font-weight: 600;
  letter-spacing: normal;
  font-size: 1rem;
  color: $h5-color !important;
}

.w-help-tab-content {
  @extend .w-p1;
  color: $h5-color !important;
  overflow: auto;

  ::v-deep h1 {
    color: var(--v-secondary_font_color-base) !important;
  }

  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4,
  ::v-deep h5,
  ::v-deep ol,
  ::v-deep ul {
    margin-bottom: #{$grid-gutter};
  }
}
</style>
